import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { ArticleDetailInterface } from "@/components/ArticlePage/api/interface";
import { ArticleState } from "@/components/ArticlePage/redux/types";

const selectArticle = (state: RootState): ArticleState => state?.article;

export default createDraftSafeSelector(
  selectArticle,
  (article: ArticleState): ArticleDetailInterface => article.articleData
);
